import { useEffect, useState } from 'react';
import useSWR from 'swr';
import urlcat from 'urlcat';
import getAuthClient from 'Tasking_Helpers/getAuthClient';

const requestPath = 'v1/pets/:userId/history';

const retrieveApiHistory = async (url) => {
  const authorizedApiClient = await getAuthClient();

  if (authorizedApiClient) {
    return await authorizedApiClient.get(url);
  }
};

function usePetsHistory() {
  const [isPending, setIsPending] = useState(true);
  const [petHistory, setPetHistory] = useState();
  const [url, setUrl] = useState();

  const {
    data: response,
    error,
    mutate,
  } = useSWR(() => url, retrieveApiHistory, {
    revalidateOnFocus: false,
  });

  const getPetHistory = (userId) => {
    setUrl(urlcat(process.env.API_BASE_URL, requestPath, { userId }));
    mutate(response);
  };

  useEffect(() => {
    if (response) {
      setPetHistory(response.data);
    }

    setIsPending(!response && !error);
  }, [response, error]);

  return { petHistory, error, isPending, getPetHistory };
}

export default usePetsHistory;
